import {
  Box,
  Button,
  Paper,
  Typography,
  TextField,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { GridRowModes, DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import DehazeIcon from '@mui/icons-material/Dehaze';
import toast, { Toaster } from "react-hot-toast";
import Swal from "sweetalert2";
import * as services from "../../services/services";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import SearchIcon from "@mui/icons-material/Search";

const PetList = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [openOwnerDialog, setOpenOwnerDialog] = useState(false);
  const [newOwner, setNewOwner] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    idCard: "",
    address: "",
    subDistrict: "",
    district: "",
    province: "",
  });

  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const keyword = searchText.toLowerCase();

  const filtered = rows.filter(
    (p) =>
      p.name.toLowerCase().includes(keyword) ||
      p.ownerCode.toLowerCase().includes(keyword) ||
      p.phone.toLowerCase().includes(keyword),
  );

  const columns = [
    { field: "no", headerName: "No", flex: 0.5 },
    { field: "ownerCode", headerName: "IDเจ้าของ", flex: 1 },
    { field: "name", headerName: "ชื่อ-นามสกุล เจ้าของ", flex: 1 },
    { field: "phone", headerName: "เบอร์โทรศัพท์", flex: 2 },
    { field: "address", headerName: "ที่อยู่", flex: 2 },
    {
      field: "edit",
      headerName: "รายละเอียด",
      flex: 0.7,
      renderCell: (params) => (
        <Button
          size="small"
          variant="outlined"
          startIcon={<DehazeIcon />}
          onClick={() => navigate(`/owner/${params.row.id}`)}
        >
          รายละเอียด
        </Button>
      ),
    },

    // {
    //   field: "detail",
    //   headerName: "รายละเอียด",
    //   flex: 1,
    //   renderCell: (params) => (
    //     <div
    //       style={{
    //         display: "flex",
    //         justifyContent: "center", // กึ่งกลางแนวนอน
    //         alignItems: "center", // กึ่งกลางแนวตั้ง
    //         width: "100%",
    //         height: "100%",
    //       }}
    //     >
    //       <AssignmentIcon
    //         style={{ color: "#1976d2", cursor: "pointer" }}
    //         onClick={() => {
    //           navigate(`/pets/${params.row.id}`, {
    //             state: params.row,
    //           });
    //         }}
    //       />
    //     </div>
    //   ),
    // },
  ];
  const fetchHistory = useCallback(async () => {
    const res = await services.getOwnersByHospital();
    const rawData = res.data.data;
    const productsWithIndex = rawData.map((item, index) => ({
      ...item,
      no: index + 1,
      ownerCode: item.ownerCode,
      name: item.firstName + " " + item.lastName,
      phone: item.phoneNumber,
      address: [item.address, item.subDistrict, item.district, item.province]
        .filter(Boolean)
        .join(" "),
    }));

    setRows(productsWithIndex);
    setLoading(false);
  }, []);

  const handleFile = (file) => {
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handleDrop = (e) => {
    e.preventDefault();

    if (
      e.dataTransfer &&
      e.dataTransfer.files &&
      e.dataTransfer.files.length > 0
    ) {
      handleFile(e.dataTransfer.files[0]);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    fetchHistory();
  }, [fetchHistory]);

  const handleCreateOwner = async () => {
    try {
      let imageUrl = null;

      if (imageFile) {
        const uploadRes = await services.uploadImage(imageFile, "owner");
        imageUrl = uploadRes.data.url;
      }

      const res = await services.createOwner({
        ...newOwner,
        imageUrl,
      });

      toast.success("เพิ่มเจ้าของสำเร็จ");
      fetchHistory();
      setOpenOwnerDialog(false);
      setNewOwner({
        firstName: "",
        lastName: "",
        phoneNumber: "",
        idCard: "",
        address: "",
        subDistrict: "",
        district: "",
        province: "",
      });

      setImageFile(null);
      setImagePreview(null);
    } catch (err) {
      console.log(err);
      if (err.status === 409) {
        toast.error("เพิ่มเจ้าของไม่สำเร็จ มีเลขบัตรนี้ในระบบแล้ว");
      } else {
        toast.error("เพิ่มเจ้าของไม่สำเร็จ");
      }
    }
  };

  return (
    <>
      <AppBreadcrumbs />
      <Toaster position="bottom-left" reverseOrder={false} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          flexWrap: "wrap",
          gap: 2,
          my: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "stretch", sm: "center" },
            gap: 2,
            flex: 1,
            minWidth: 0,
          }}
        >
          <Typography component="h2" variant="h5" sx={{ whiteSpace: "nowrap" }}>
            รายการเจ้าของ
          </Typography>
          <TextField
            fullWidth
            label="ค้นหา"
            placeholder="ชื่อ/นามสกุล/IDเจ้าของ/เบอร์โทรศัพท์"
            variant="outlined"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            sx={{ maxWidth: { xs: "100%", sm: 420 } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/owner/create')}
          sx={{ whiteSpace: "nowrap", height: 40 }}
        >
          เพิ่มเจ้าของ
        </Button>
      </Box>

      <Box sx={{ flex: 1, position: "relative" }}>
        <Box sx={{ position: "absolute", inset: 0 }}>
          <Paper>
            <DataGrid rows={filtered} columns={columns} loading={loading} />
          </Paper>
        </Box>
      </Box>
      <Dialog open={openOwnerDialog} onClose={() => setOpenOwnerDialog(false)}>
        <DialogTitle>เพิ่มเจ้าของใหม่</DialogTitle>

        <DialogContent sx={{ minWidth: 400 }}>
          <TextField
            label="ชื่อ"
            fullWidth
            sx={{ mt: 1 }}
            value={newOwner.firstName}
            onChange={(e) =>
              setNewOwner({ ...newOwner, firstName: e.target.value })
            }
          />
          <TextField
            label="นามสกุล"
            fullWidth
            sx={{ mt: 2 }}
            value={newOwner.lastName}
            onChange={(e) =>
              setNewOwner({ ...newOwner, lastName: e.target.value })
            }
          />
          <TextField
            label="เลขบัตรประชาชน"
            fullWidth
            sx={{ mt: 2 }}
            value={newOwner.idCard}
            onChange={(e) =>
              setNewOwner({ ...newOwner, idCard: e.target.value })
            }
          />
          <TextField
            label="เบอร์โทร"
            fullWidth
            sx={{ mt: 2 }}
            value={newOwner.phoneNumber}
            onChange={(e) =>
              setNewOwner({ ...newOwner, phoneNumber: e.target.value })
            }
          />{" "}
          <TextField
            label="ที่อยู่"
            fullWidth
            sx={{ mt: 2 }}
            value={newOwner.address}
            onChange={(e) =>
              setNewOwner({ ...newOwner, address: e.target.value })
            }
          />{" "}
          <TextField
            label="ตำบล"
            fullWidth
            sx={{ mt: 2 }}
            value={newOwner.subDistrict}
            onChange={(e) =>
              setNewOwner({ ...newOwner, subDistrict: e.target.value })
            }
          />
          <TextField
            label="อำเภอ"
            fullWidth
            sx={{ mt: 2 }}
            value={newOwner.district}
            onChange={(e) =>
              setNewOwner({ ...newOwner, district: e.target.value })
            }
          />{" "}
          <TextField
            label="จังหวัด"
            fullWidth
            sx={{ mt: 2 }}
            value={newOwner.province}
            onChange={(e) =>
              setNewOwner({ ...newOwner, province: e.target.value })
            }
          />
          <Box
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            sx={{
              mt: 2,
              p: 2,
              border: "2px dashed #ccc",
              borderRadius: 2,
              textAlign: "center",
              backgroundColor: "#fafafa",
              "&:hover": {
                backgroundColor: "#f0f0f0",
              },
            }}
            onClick={() =>
              document.getElementById("owner-image-input")?.click()
            }
          >
            {imagePreview ? (
              <img
                src={imagePreview}
                alt="preview"
                style={{ maxWidth: "100%", maxHeight: 200, borderRadius: 8 }}
              />
            ) : (
              <Typography color="text.secondary">
                คลิกหรือ ลากรูปภาพมาวางที่นี่
              </Typography>
            )}
            <input
              id="owner-image-input"
              type="file"
              accept="image/*"
              hidden
              onChange={(e) => {
                if (e.target.files && e.target.files.length > 0) {
                  handleFile(e.target.files[0]);
                }
              }}
            />
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setOpenOwnerDialog(false);
            }}
          >
            ยกเลิก
          </Button>

          <Button variant="contained" onClick={handleCreateOwner}>
            บันทึกเจ้าของ
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PetList;
